import React from 'react'
import TimePicker from "react-time-picker"

export default function Picker(props) {
    
    return (
      <TimePicker
        value={props.time}
        onChange={props.setTime}
        clearIcon={null}
        disableClock={true}
      />
    )
}
